import { apiGet, apiPost } from '../client';
import { CueAcknowledgeResponseSchema, CueResponseSchema, type CueResponse } from '../schemas';

export function getBookingCue(bookingId: string): Promise<CueResponse> {
  return apiGet(`/v1/bookings/${encodeURIComponent(bookingId)}/cue`, CueResponseSchema);
}

export function getCustomerCue(customerId: string, businessId: string): Promise<CueResponse> {
  const params = new URLSearchParams({ customerId, businessId });
  return apiGet(`/v1/profile/cue?${params.toString()}`, CueResponseSchema);
}

export function acknowledgeCue(
  bookingId: string,
  cueId: string,
  idempotencyKey: string,
): Promise<{ acknowledgedAt: string }> {
  return apiPost(
    `/v1/bookings/${encodeURIComponent(bookingId)}/cue/acknowledge`,
    CueAcknowledgeResponseSchema,
    { cueId },
    idempotencyKey,
  );
}
